import { render, staticRenderFns } from "./SendReview.vue?vue&type=template&id=e1013928&scoped=true&"
import script from "./SendReview.vue?vue&type=script&lang=js&"
export * from "./SendReview.vue?vue&type=script&lang=js&"
import style0 from "./SendReview.vue?vue&type=style&index=0&id=e1013928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1013928",
  null
  
)

export default component.exports